import React, { useCallback, useContext, useEffect, useState } from 'react';
import AccountContext from 'contexts/AccountContext';
import AccountPickerContext from 'contexts/AccountPickerContext';
import STORE from 'store';
import firebase from 'firebase/compat/app';

export const AccountTodayOverrideContext = React.createContext<{
  todayOverride: string | undefined;
  onTodayOverrideUpdated: (todayOverride: string | undefined) => Promise<void>;
  isTransient: boolean;
}>({
  todayOverride: undefined,
  onTodayOverrideUpdated: () => Promise.resolve(),
  isTransient: true,
});

const AccountTodayOverrideProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { isDemoAccount } = useContext(AccountContext);
  const [todayOverride, setTodayOverride] = useState<string | undefined>();

  useEffect(() => {
    STORE.getAccountRef({
      accountId: selectedAccountId,
    })
      .get()
      .then((accountDoc) => {
        const account = accountDoc.data();
        if (!account || !account.isDemoAccount) {
          setTodayOverride(undefined);
          return;
        }

        setTodayOverride(account.todayOverride);
      });
  }, [selectedAccountId]);

  const onTodayOverrideUpdated = useCallback(
    async (newTodayOverride: string | undefined) => {
      if (!isDemoAccount) {
        setTodayOverride(newTodayOverride);
        return;
      }

      return STORE.getAccountRef({
        accountId: selectedAccountId,
      })
        .update({
          todayOverride:
            newTodayOverride === undefined
              ? firebase.firestore.FieldValue.delete()
              : newTodayOverride,
        })
        .then(() => {
          setTodayOverride(newTodayOverride);
        });
    },
    [isDemoAccount, selectedAccountId],
  );

  return (
    <AccountTodayOverrideContext.Provider
      value={{
        todayOverride,
        onTodayOverrideUpdated,
        isTransient: !isDemoAccount,
      }}
    >
      {children}
    </AccountTodayOverrideContext.Provider>
  );
};

export default AccountTodayOverrideProvider;
